export const PAGE_SIZES = [5, 10, 15, 20, 25, 50, 100, 250];


// WEBPACK FOOTER //
// ./src/constants/pagination-page-size-increase.js